import { Component, OnDestroy, OnInit, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { AdesaoStatus } from '../../core/enum/adesao-status.enum';
import { AdesaoFiltros } from '../../core/models/adesao.model';

export interface AdesaoStatusOption {
  value: string;
  label: string;
}

const DEBOUNCE_MS = 300;

@Component({
  selector: 'app-adesao-filter-bar',
  imports: [ReactiveFormsModule],
  templateUrl: './adesao-filter-bar.component.html',
  styleUrl: './adesao-filter-bar.component.scss',
})
export class AdesaoFilterBarComponent implements OnInit, OnDestroy {
  private readonly fb = inject(FormBuilder);

  readonly periodoDe = input<string>('');
  readonly periodoAte = input<string>('');

  readonly filtersChange = output<AdesaoFiltros>();

  readonly statusOptions: AdesaoStatusOption[] = [
    { value: 'todos', label: 'Todos' },
    { value: AdesaoStatus.Pendente, label: 'Pendente' },
    { value: AdesaoStatus.Solicitado, label: 'Solicitado' },
    { value: AdesaoStatus.Concluido, label: 'Concluído' },
    { value: AdesaoStatus.Cancelada, label: 'Cancelada' },
  ];

  readonly form = this.fb.nonNullable.group({
    nome: '',
    status: 'todos',
    data: '',
  });

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(debounceTime(DEBOUNCE_MS), takeUntil(this.destroy$))
      .subscribe(() => this.emitFilters());

    this.emitFilters();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private emitFilters(): void {
    const { nome, status, data } = this.form.getRawValue();
    const filtros: AdesaoFiltros = {};

    const termo = nome.trim();
    if (termo) {
      filtros.nome = termo;
    }

    if (status && status !== 'todos') {
      filtros.status = status;
    }

    if (data) {
      filtros.data = data;
    }

    this.filtersChange.emit(filtros);
  }
}
